import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Keycloak from '@gcube/keycloak-js';
import { BehaviorSubject } from 'rxjs';
import { environment } from "../../environments/environment";
import { WindowRef } from '../shared-service/windowRef.service';
import  { KeycloakInitOptions } from '@gcube/keycloak-js';

@Injectable()

export class AuthOIDCService {
    keycloak = new Keycloak(environment.keycloakConfigOptions);
    authState = new BehaviorSubject(false);

    constructor(private router: Router,private winRef: WindowRef){}

    AuthInit(path: string = '/'): Promise<any>{
        return new Promise((resolve, reject) => {
            this.keycloak
            .init(
                /** @type {?} */ {
                ...environment.keycloakInitOptions as KeycloakInitOptions,
                redirectUri: environment.keycloakInitOptions.redirectUri + path
            })
            .then((isAuth:boolean) => {
                this.authState.next(true);
                resolve(isAuth);
            })
            .catch((error: Keycloak.KeycloakError) => {
                this.authState.next(false);
                console.log('auth service init error', error);
                reject(false);
            });
        });
    }

    login(path: string = '/'): Promise<any>{
        return new Promise((resolve, reject) => {
            this.keycloak
            .login(({
                redirectUri: environment.keycloakInitOptions.redirectUri + path
            }))
            .then(isAuth => {
                this.authState.next(true);
                resolve(true);
            })
            .catch(error => {
                this.authState.next(false);
                console.log('auth service login error', error);
                reject('Auth server login unsuccessful!');
            });
        });
    }

    refreshToken(): void{
        this.keycloak.isTokenExpired()
    }

    updateToken(number = 0): void{
        this.keycloak.updateToken(number)
        .then((isAuth) => {
            this.authState.next(true);
        }).catch((err) => {
            this.authState.next(false);
            console.log(err);
        });
	}

    logout(path = '/'){
        this.winRef.nativeWindow.document.cookie.split(';').forEach((c:any)=>{
            this.winRef.nativeWindow.document.cookie = c.trim().split('=')[0] + '=;' + 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
        });
        localStorage.clear();
        sessionStorage.clear();
        if(this.isTokenExpired || !this.idToken){
            this.router.navigate(['/login']);
        }else{
            this.keycloak
            .logout(({
                redirectUri: environment.keycloakInitOptions.redirectUri + path
            }))
            .then(isAuth => {
                this.authState.next(false);
            })
            .catch(error => {
                this.authState.next(true);
                console.log('auth service logout error', error);
            });
        }
    }

    get isAuthenticated(){
        
        return this.keycloak.authenticated;
    }

    get isTokenExpired() {
        return this.keycloak.isTokenExpired(0);
    }

    get token(){
        return this.keycloak.token;
    }

    get idToken(){
        return this.keycloak.idToken;
    }

    get user(){
        return this.keycloak.tokenParsed;
    }

}
